const padPrintNo = (printNo: number | string): string => `${printNo}`.padStart(3, '0');

export default padPrintNo;
